import { PAINT_COLORS } from '../../constants/colors'
import { usePaintStore } from '../../state/paintStore'
import { ColorSwatch } from './ColorSwatch'
import './ColorPalette.css'

export function ColorPalette() {
  const color = usePaintStore((s) => s.color)
  const setColor = usePaintStore((s) => s.setColor)

  return (
    <section className="color-palette" aria-label="Colors">
      {PAINT_COLORS.map((c) => (
        <ColorSwatch
          key={c.id}
          hex={c.hex}
          name={c.name}
          active={color.id === c.id}
          onClick={() => setColor(c.id)}
        />
      ))}
    </section>
  )
}
